import { inject, Injectable } from '@angular/core';
import { RemoteConfigService, WINDOW } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class DiscordBotIntegrationService {
    private readonly remoteConfigService = inject(RemoteConfigService);
    private readonly window = inject(WINDOW);

    public integrate(): void {
        const botUrl = this.remoteConfigService.getItem('discordBotUrl').asString();

        this.window.open(botUrl, '_blank');
    }
}
